import firebase from "../../config/firebase";
import algoliasearch from "algoliasearch";
import { createNullCache } from "@algolia/cache-common";
const client = algoliasearch("GPYJEAVUBP", "b1f999bc5b264defe930762391d240c6", {
  responsesCache: createNullCache(),
});

let OrderIndex = client.initIndex("orders");
let usersIndex = client.initIndex("users");

export const getAllCustomers =
  (ID, searchValue, currentPage, gender, value, hitsPerPage) =>
  async (dispatch) => {
    const minAge = value[0];
    const maxAge = value[1];
    const maxHitsPerPage = 250;

    dispatch(customerLoader(true));

    try {
      const initialResponse = await OrderIndex.search("", {
        filters: `restaurantID:${ID}`,
        hitsPerPage: 1,
        page: 0,
      });

      const totalHits = initialResponse.nbHits;
      const totalPages = Math.ceil(totalHits / maxHitsPerPage);

      let allHits = [];

      for (let page = 0; page < totalPages; page++) {
        const response = await OrderIndex.search("", {
          filters: `restaurantID:${ID}`,
          hitsPerPage: maxHitsPerPage,
          page,
        });

        allHits = [...allHits, ...response.hits];
      }

      const uniqueCustomerIDs = [
        ...new Set(
          allHits
            .map((hit) => hit.customerID)
            .filter((id) => id && id.trim() !== "")
        ),
      ];

      if (uniqueCustomerIDs.length === 0) {
        dispatch({ type: "GET_ALL_CUSTOMER", payload: [] });
        dispatch({
          type: "CUSTOMER_DETAILS",
          payload: { nbHits: 0, nbPages: 0, hitsPerPage },
        });
        return;
      }

      const customerIDFilter = uniqueCustomerIDs
        .map((id) => `objectID:${id}`)
        .join(" OR ");

      let customerFilters = `(${customerIDFilter}) AND type:'customer' AND (age >= ${minAge} AND age <= ${maxAge})`;

      if (gender !== "all") {
        customerFilters += ` AND gender:'${gender}'`;
      }

      const customerResponse = await usersIndex.search(searchValue, {
        filters: customerFilters,
        hitsPerPage,
        page: currentPage,
      });

      dispatch({
        type: "GET_ALL_CUSTOMER",
        payload: customerResponse.hits,
      });

      dispatch({
        type: "CUSTOMER_DETAILS",
        payload: {
          nbHits: customerResponse.nbHits,
          nbPages: customerResponse.nbPages,
          hitsPerPage,
          currentPage,
        },
      });
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      dispatch(customerLoader(false));
    }
  };

export const getAllCustomersForRestaurant = (ID) => async (dispatch) => {
  const maxHitsPerPage = 250;

  try {
    const initialResponse = await OrderIndex.search("", {
      filters: `restaurantID:${ID}`,
      hitsPerPage: 1,
      page: 0,
    });

    const totalHits = initialResponse.nbHits;
    const totalPages = Math.ceil(totalHits / maxHitsPerPage);

    let allHits = [];

    for (let page = 0; page < totalPages; page++) {
      const response = await OrderIndex.search("", {
        filters: `restaurantID:${ID}`,
        hitsPerPage: maxHitsPerPage,
        page,
      });

      allHits = [...allHits, ...response.hits];
    }

    const uniqueCustomerIDs = [
      ...new Set(
        allHits
          .map((hit) => hit.customerID)
          .filter((id) => id && id.trim() !== "")
      ),
    ];

    if (uniqueCustomerIDs.length === 0) {
      dispatch({ type: "GET_ALL_CUSTOMERS_FOR_RESTAURANT", payload: [] });
      return;
    }

    const customerIDFilter = uniqueCustomerIDs
      .map((id) => `objectID:${id}`)
      .join(" OR ");

    let customerFilters = `(${customerIDFilter}) AND type:'customer'`;

    const customerResponse = await usersIndex.search("", {
      filters: customerFilters,
      hitsPerPage: uniqueCustomerIDs.length,
    });

    dispatch({
      type: "GET_ALL_CUSTOMERS_FOR_RESTAURANT",
      payload: customerResponse.hits,
    });
  } catch (error) {
    console.error("Error fetching all customers:", error);
  }
};

export const addCustomer = (customerData) => {
  return async (dispatch) => {
    try {
      const db = firebase.firestore();

      if (customerData?.addToExisting) {
        const existingCustomerSnapshot = await db
          .collection("users")
          .where("type", "==", "customer")
          .where("contactNumber", "==", customerData.phoneNo)
          .limit(1)
          .get();

        if (!existingCustomerSnapshot.empty) {
          const existingCustomer = existingCustomerSnapshot.docs[0];
          return {
            success: true,
            customerID: existingCustomer.id,
            existing: true,
          };
        } else {
          return {
            success: false,
            error: "No customer record exists with given phone number.",
            existing: false,
          };
        }
      }

      const newCustomerRef = db.collection("users").doc();

      const newCustomer = {
        id: newCustomerRef.id, // customerId
        type: "customer",
        name: customerData.name || "",
        contactNumber: customerData.phoneNo || "",
        gender: customerData.gender || "",
        DOB: "", // string
        address: "",
        age: 0, // number
        createdAt: firebase.firestore.Timestamp.now(),
        email: "--WAITER-CUSTOMER--",
        imageURL: "",
        onetimelogin: false,
      };

      await newCustomerRef.set(newCustomer);

      return { success: true, customerID: newCustomerRef.id };
    } catch (error) {
      console.error("Error adding customer:", error);
      return { success: false, error };
    }
  };
};

export const checkExistingCustomer = (phoneNumber) => {
  return async (dispatch) => {
    try {
      const db = firebase.firestore();

      if (phoneNumber) {
        const existingCustomerSnapshot = await db
          .collection("users")
          .where("type", "==", "customer") // Only check among customers
          .where("contactNumber", "==", phoneNumber)
          .limit(1)
          .get();

        if (!existingCustomerSnapshot.empty) {
          const docSnap = existingCustomerSnapshot.docs[0];
          const data = docSnap.data();

          return {
            success: true,
            customerID: docSnap.id,
            customerName: data.name,
            customerGender: data.gender,
            existing: true,
          };
        } else {
          return {
            success: false,
            error: "No customer record exists with given phone number.",
            existing: false,
          };
        }
      }
      return {
        success: false,
        error: "Invalid Phone Number",
        existing: false,
      };
    } catch (error) {
      console.error("Error checking for customer:", error);
      return { success: false, error };
    }
  };
};

export const getCustomerByID = (customerID) => {
  return async (dispatch) => {
    try {
      const db = firebase.firestore();

      const customerDoc = await db.collection("users").doc(customerID).get();

      if (customerDoc.exists) {
        const customerData = customerDoc.data();

        dispatch({
          type: "SET_UPDATED_CUSTOMER_DATA",
          payload: customerData,
        });
      } else {
        dispatch({
          type: "SET_UPDATED_CUSTOMER_DATA",
          payload: null,
        });
      }
    } catch (error) {
      console.error("Error fetching customer:", error);
      dispatch({
        type: "SET_UPDATED_CUSTOMER_DATA",
        payload: null,
      });
    }
  };
};

export const updateCustomerByID = (customerID, customerData) => {
  return async (dispatch) => {
    try {
      const db = firebase.firestore();

      await db
        .collection("users")
        .doc(customerID)
        .update({
          name: customerData.name || "",
          contactNumber: customerData.phoneNo || "",
          gender: customerData.gender || "",
        });

      // Fetch the updated doc
      const updatedDoc = await db.collection("users").doc(customerID).get();

      if (updatedDoc.exists) {
        return { success: true };
      }

      return { success: false };
    } catch (error) {
      console.error("Error updating customer:", error);
      return { success: false, error };
    }
  };
};

const customerLoader = (data) => async (dispatch) => {
  dispatch({
    type: "CUSTOMER_LOADER",
    payload: data,
  });
};
